import Tippy from "@tippyjs/react";
import { useMemo } from "react";
import { FaAddressBook, FaCalculator, FaLink, FaRegFile } from "react-icons/fa";
import "./FieldAvailableItem.scss";
import { FieldAvailable } from "./get-fields-available";

const IconSize = 12;

interface FieldAvailableItemProps {
  field: FieldAvailable;
  type: "available" | "selected";
  onClick: (field: FieldAvailable) => void;
}

const FieldAvailableItem: React.FC<FieldAvailableItemProps> = ({
  field,
  type,
  onClick,
}) => {
  const typeIcon = useMemo(() => {
    let icon: React.ReactNode | null = null;
    let text: string = "";

    if (field.type === "string") {
      icon = <FaRegFile size={IconSize} />;
      text = "String";
    }

    if (field.type === "email") {
      icon = <FaAddressBook size={IconSize} />;
      text = "Email";
    }

    if (field.type === "number") {
      icon = <FaRegFile size={IconSize} />;
      text = "Number";
    }

    if (field.type === "url") {
      icon = <FaLink size={IconSize} />;
      text = "URL";
    }

    if (!icon || !text) {
      return null;
    }

    return <Tippy content={text}>{icon}</Tippy>;
  }, [field.type]);

  return (
    <div className={`field field-${type}`} onClick={() => onClick(field)}>
      {field.name}
      <div className="icon-tray">
        {field.computed && (
          <Tippy content="Computed field" className="computed-indicator">
            <FaCalculator size={IconSize} />
          </Tippy>
        )}
        {typeIcon}
      </div>
    </div>
  );
};

export default FieldAvailableItem;
